<mat-select [formControl]="form" [placeholder]="'LABEL.USER_GROUP' | translate " [compareWith]="compareGroups">
  @for (group of groups; track group.id) {
    <mat-option [value]="group">
      {{ group.name }}
    </mat-option>
  }
</mat-select>
